import { createSlice } from '@reduxjs/toolkit';

interface IAppStatusState {
  maintenanceMode: boolean;
  serviceUnavailableMode: boolean;
}

const initialState: IAppStatusState = {
  maintenanceMode: false,
  serviceUnavailableMode: false,
};

const appStatusSlice = createSlice({
  name: 'appStatus',
  initialState,
  reducers: {
    enableMaintenanceMode: (state) => {
      state.maintenanceMode = true;
    },
    enableServiceUnavailableMode: (state) => {
      state.serviceUnavailableMode = true;
    },
  },
});

export const { enableMaintenanceMode, enableServiceUnavailableMode } =
  appStatusSlice.actions;
export default appStatusSlice.reducer;
